import request from "@/plugins/axios"
//商品黑名单设置
let prefix = "eids-invoice/prodblacklist"

export function obtain(orgId) {
  return request({
    url: prefix + '/obtain/' + orgId,
    method: 'get',
  })
}

export function save(prodblacklistDto) {
  return request({
    url: prefix + '/set',
    method: 'post',
    data: prodblacklistDto,
  })
}
